import { ProductItemV2 } from '../product';
import { CategoriesProductsProductDto } from '../api/categories';

export class CategoryProductItemV2 extends ProductItemV2 {
  productCategoryLinkDate: string;
  constructor(categoryProductItem: CategoriesProductsProductDto) {
    super(categoryProductItem);
    this.productCategoryLinkDate = categoryProductItem.productCategoryLinkDate;
  }
}
